import createReactComponent from '../createReactComponent';
var ThermometerSun = createReactComponent('ThermometerSun', [['path', {
  d: 'M12 9a4 4 0 00-2 7.5',
  key: '1q9yus'
}], ['path', {
  d: 'M12 3v2',
  key: '1w22ol'
}], ['path', {
  d: 'M6.6 18.4l-1.4 1.4',
  key: '1nwqxq'
}], ['path', {
  d: 'M18 2a2 2 0 012 2v10.5a4 4 0 11-4 0V4c0-1.1.9-2 2-2z',
  key: 'x7opdx'
}], ['path', {
  d: 'M4 13H2',
  key: '118le4'
}], ['path', {
  d: 'M6.6 7.6L5.2 6.2',
  key: '14dtg7'
}]]);
export default ThermometerSun;